import { render, staticRenderFns } from "./OtherContractsTab.vue?vue&type=template&id=26c71d84&"
import script from "./OtherContractsTab.vue?vue&type=script&lang=js&"
export * from "./OtherContractsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports